type ProductNameProps = {
  className?: string
}

export const ProductName = ({ className = '' }: ProductNameProps) => {
  return (
    <span className={`text-brand-blue font-semibold ${className}`.trim()}>
      Resilience Explorer® | Property
    </span>
  )
}

export default ProductName
